import { AdditiveBlending, Object3D, PlaneGeometry } from 'three';
import { Reflector } from 'three/examples/jsm/objects/Reflector';
import { appMixin } from '../../utils/appMixin';

import { vert } from '../Materials/Ground/vertex';
import { frag } from '../Materials/Ground/fragment';

export class Ground extends appMixin(Object3D) {
  constructor(app) {
    super(app);

    this.reflector = new Reflector(new PlaneGeometry(10, 10), {
      color: 0x000000,
      textureWidth: 512,
      textureHeight: 512,
      clipBias: 0,
      multisample: 0,
      shader: {
        vertexShader: vert,
        fragmentShader: frag,
        uniforms: {
          color: { value: null },
          tDiffuse: { value: null },
          tNoise: { value: this.app.tools.noise.texture },
          tLinearNoise: { value: this.app.tools.noise.linearTexture },
          textureMatrix: { value: null },
          uColor: { value: null },
          uTime: { value: null },
        },
      },
    });
    this.reflector.material.transparent = true;

    this.reflector.material.blending = AdditiveBlending;
    this.reflector.material.uniforms.uTime = this.app.uniforms.uTime;
    this.reflector.material.uniforms.uColor = this.app.uniforms.uColor;

    this.reflector.rotation.x = -Math.PI * 0.5;

    this.add(this.reflector);
  }
}
